import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideAlertInfoAction, showAlertInfoAction, clearAlertInfoAction } from '@redux/alert/alertActions';
import { AlertConfig } from '@redux/alert/alertTypes';
import { RootState } from '@redux/store';
import GreenBgCheckmark from 'assets/images/greenBgCheckmark.png';
import RedBgExclamation from 'assets/images/redBgExclamation.png';

const DEFAULT_ALERT_DURATION = 5000;

export const useAlert = () => {
  const dispatch = useDispatch();
  const isAlertVisible = useSelector((state: RootState) => state.alert.isAlertVisible);

  const showAlertInfo = useCallback(
    (config: AlertConfig) => {
      const show = () => {
        dispatch(
          showAlertInfoAction({
            ...config,
            title: config.title || 'Success!',
            iconSrc: config.iconSrc || GreenBgCheckmark
          })
        );

        setTimeout(hideAlert, config.duration || DEFAULT_ALERT_DURATION);
      };

      if (isAlertVisible) {
        dispatch(hideAlertInfoAction());
        setTimeout(show, 500);
      } else {
        show();
      }
    },
    [isAlertVisible]
  );

  const showAlertWarning = useCallback(
    (config: Omit<AlertConfig, 'iconSrc'>) => {
      const show = () => {
        dispatch(
          showAlertInfoAction({
            ...config,
            title: config.title || 'Oops!',
            iconSrc: RedBgExclamation
          })
        );

        setTimeout(hideAlert, config.duration || DEFAULT_ALERT_DURATION);
      };

      if (isAlertVisible) {
        dispatch(hideAlertInfoAction());
        setTimeout(show, 500);
      } else {
        show();
      }
    },
    [isAlertVisible]
  );

  const hideAlert = useCallback(() => {
    dispatch(hideAlertInfoAction());
    setTimeout(() => {
      dispatch(clearAlertInfoAction());
    }, 100);
  }, []);

  return {
    showAlertInfo: showAlertInfo,
    showAlertWarning: showAlertWarning,
    hideAlert
  };
};
